<template>
  <div class="container my-4">
    <div class="alert alert-primary" role="alert">
      <h3><i class="bi bi-person-plus-fill"></i> Add Student</h3>
    </div>

    <!-- Form for adding a student -->
    <form @submit.prevent="handleSubmit" class="bg-light p-4 rounded shadow-sm">

      <!-- STEP 1 -->
      <div v-show="currentStep === 1">
        <!-- First Name -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-person-badge-fill"></i>
            </span>
            <input
              v-model="student.first_name"
              type="text"
              class="form-control"
              placeholder="Enter student first name"
              required
            />
          </div>
        </div>

        <!-- Last Name -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-person-badge"></i>
            </span>
            <input
              v-model="student.last_name"
              type="text"
              class="form-control"
              placeholder="Enter student last name"
              required
            />
          </div>
        </div>

        <!-- Age -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-hourglass-split"></i>
            </span>
            <input
              v-model="student.age"
              type="number"
              class="form-control"
              placeholder="Enter student age"
              required
            />
          </div>
        </div>

        <!-- Birth Date -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-calendar-event-fill"></i>
            </span>
            <input
              v-model="student.birth_day"
              type="date"
              class="form-control"
              required
            />
          </div>
        </div>

        <!-- Gender -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-gender-ambiguous"></i>
            </span>
            <select v-model="student.gender" class="form-select" required>
              <option value="gender" disabled>Select Gender</option>
              <option value="male"><i class="bi bi-gender-male"></i> Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>

        <!-- Contact -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-telephone-fill"></i>
            </span>
            <input
              v-model="student.contact"
              type="text"
              class="form-control"
              placeholder="Enter student phone number"
              required
            />
          </div>
        </div>

          <!-- Success Message -->
  <div v-if="successMessage" class="alert alert-success">
    <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
  </div>

  <!-- Error Message -->
  <div v-if="errorMessage" class="alert alert-danger">
    <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
  </div>

        <div class="btnClassA">
          <button @click="nextStep" class="btn btn-primary fieldClass" type="button">
            <i class="bi bi-arrow-right-circle"></i> Next
          </button>
        </div>
      </div>

      <!-- STEP 2 -->
      <div v-show="currentStep === 2">
        <h3><i class="bi bi-journal-text"></i> Item Details</h3>

        <!-- Grade -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-mortarboard-fill"></i>
            </span>
            <select v-model="student.gradeId" class="form-select">
              <option value="" disabled>Select Grade</option>
              <option v-for="grade in grades" :key="grade.id" :value="grade.id">
                Grade {{ grade.grade_level }}
              </option>
            </select>
          </div>
        </div>

        <!-- Subject -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-book-fill"></i>
            </span>
            <select v-model="student.subjectId" class="form-select">
              <option value="" disabled>Select Subject</option>
              <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
                {{ subject.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Institute -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-building-fill"></i>
            </span>
            <select v-model="student.instituteId" class="form-select">
              <option value="" disabled>Select Institute</option>
              <option v-for="institute in institutes" :key="institute.id" :value="institute.id">
                {{ institute.institute_name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Registration Number -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-hash"></i>
            </span>
            <input
              v-model="student.stu_reg_number"
              type="text"
              class="form-control"
              placeholder="Enter student registration number"
              required
            />
          </div>
        </div>

        <div class="btnClassA d-flex justify-content-between gap-2">
          <button @click="prevStep" class="btn btn-secondary fieldClass" type="button">
            <i class="bi bi-arrow-left-circle"></i> Prev
          </button>
          <button @click="nextStep" class="btn btn-primary fieldClass" type="button">
            <i class="bi bi-arrow-right-circle"></i> Next
          </button>
        </div>
      </div>

      <!-- STEP 3 -->
      <!-- STEP 3 -->
<div v-show="currentStep === 3">
  <h3><i class="bi bi-credit-card-fill"></i> Account Details</h3>

  <!-- Payment Type -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-wallet2"></i>
      </span>
      <select v-model="student.payTypeId" class="form-select" required>
        <option value="" disabled>Select Payment Type</option>
        <option v-for="payType in payTypes" :key="payType.id" :value="payType.id">
          {{ payType.payment_type }}
        </option>
      </select>
    </div>
  </div>

  <!-- Amount -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-cash-stack"></i>
      </span>
      <input 
        type="number" 
        v-model="student.amount" 
        placeholder="Enter amount" 
        class="form-control" 
        required 
      />
    </div>
  </div>

  <!-- Payment Date -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-calendar-check-fill"></i>
      </span>
      <input 
        type="datetime-local" 
        v-model="student.payment_date" 
        class="form-control" 
        required 
      />
    </div>
  </div>

  <!-- Expire Date -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-calendar-x-fill"></i>
      </span>
      <input 
        type="datetime-local" 
        v-model="student.exp_date" 
        class="form-control" 
        readonly 
      />
    </div>
  </div>

  <!-- Success Message -->
  <div v-if="successMessage" class="alert alert-success">
    <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
  </div>

  <!-- Error Message -->
  <div v-if="errorMessage" class="alert alert-danger">
    <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
  </div>

  <!-- Buttons -->
  <div class="btnClassA">
    <button type="button" @click="prevStep" class="btn btn-secondary fieldClass">
      <i class="bi bi-arrow-left-circle"></i> Prev
    </button>
    <button type="submit" class="btn btn-primary w-100 mt-4" :disabled="loading">
      <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span v-if="!loading"><i class="bi bi-save-fill"></i> Add Student</span>
      <span v-else>Loading...</span>
    </button>
  </div>
</div>


    </form>
  </div>
</template>

  
  <script>
  import axios from "axios";

export default {
  data() {
    return {
      currentStep: 1,
      student: {
        subjectId: "", // Bound to the selected subject ID
        instituteId: "", // Bound to the selected institute ID
        gradeId: "", // Bound to the selected institute ID
        stu_reg_number: "",
        payTypeId:'',
        amount:'',
        gender: "gender",
        // payment_date: this.getTodayDate(),
        payment_date: this.getTodayDateTime(),
        exp_date: '',
      },
      grades: [],
      subjects: [], // Array to store subjects fetched from the API
      institutes: [], // Array to store institutes fetched from the API
      payTypes: [],
      loading: false, // Track the loading state
      successMessage: '',
      errorMessage: '',
    };
  },

  watch: {
  'student.payTypeId'() {
    if (this.student.payment_date) {
      this.calculateExpDate(); // Recalculate expiration date if payment type is changed
    }
  },
  'student.payment_date'() {
    if (this.student.payTypeId) {
      this.calculateExpDate(); // Recalculate expiration date if payment date is changed
    }
  },
},

  methods: {

    nextStep() {
  if (this.currentStep === 1) {
    if (!this.student.first_name) {
      alert("Please insert First Name");
      return;
    }
    if (!this.student.last_name) {
      alert("Please insert Last Name");
      return;
    }
    if (!this.student.age) {
      alert("Please insert Age");
      return;
    }
    if (!this.student.birth_day) {
      alert("Please insert Birth Day");
      return;
    }
    if (!this.student.gender) {
      alert("Please select Gender");
      return;
    }
    if (!this.student.contact) {
      alert("Please insert Contact Number");
      return;
    }
  } else if (this.currentStep === 2) {
    if (!this.student.gradeId) {
      alert("Please select a Grade");
      return;
    }
    if (!this.student.subjectId) {
      alert("Please select a Subject");
      return;
    }
    if (!this.student.instituteId) {
      alert("Please select an Institute");
      return;
    }
    if (!this.student.stu_reg_number) {
      alert("Please select a student register number");
      return;
    }
  }

  this.currentStep++;
},


    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    getTodayDateTime() {
    const today = new Date();
    return this.formatDateTime(today); // Format the current date and time with seconds
  },

  calculateExpDate() {
    const paymentDate = new Date(this.student.payment_date); // Get the payment date
    switch (parseInt(this.student.payTypeId)) {
      case 1: // Hourly: Add 1 hour to payment date
        paymentDate.setHours(paymentDate.getHours() + 1);
        break;
      case 2: // Daily: Add 1 day to payment date
        paymentDate.setDate(paymentDate.getDate() + 1);
        break;
      case 3: // 1 Weekly: Add 7 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 7);
        break;
      case 4: // 2 Weekly: Add 14 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 14);
        break;
      case 5: // 3 Weekly: Add 21 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 21);
        break;
      case 6: // Monthly: Add 1 month to payment date
        paymentDate.setMonth(paymentDate.getMonth() + 1);
        break;
      default:
        break;
    }

    // After modification, format the expiration date
    this.student.exp_date = this.formatDateTime(paymentDate);
  },

  formatDateTime(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // Return in the format required by <input type="datetime-local">
  return `${year}-${month}-${day}T${hours}:${minutes}`;
},

async fetchGrades() {
  try {
    const response = await axios.post("/get-grade-for-insert-student");
    this.grades = response.data;
  } catch (error) {
    console.error("Failed to fetch grades:", error);
  }
},
    async fetchSubjects() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-subjects", {
          teacher_id: teacherId,
        });
        this.subjects = response.data;
      } catch (error) {
        console.error("Failed to fetch subjects:", error);
      }
    },
    async fetchInstitutes() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-institutes", {
          teacher_id: teacherId,
        });
        this.institutes = response.data;
      } catch (error) {
        console.error("Failed to fetch institutes:", error);
      }
    },

    async fetchPayTypes() {
      try {
        const response = await axios.get('/getPayTypes');
        this.payTypes = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching Payement types.';
      }
    },
    


    async handleSubmit() {
      this.loading = true; // Start the loading spinner
      try {
        const teacherId = localStorage.getItem("teacher_id");

        const studentData = {
          ...this.student,
          teacher_id: teacherId,
        };

        const response = await axios.post("/addStudent", studentData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (response.data.success) {
          this.successMessage = "Student added successfully!";
          this.errorMessage = '';

          // Clear the success message after 5 seconds
          setTimeout(() => {
            this.successMessage = '';
          }, 5000);

          this.student = {
            first_name: '',
            last_name: '',
            age: '',
            birth_day: '',
            gender: 'gender',
            contact: '',
            gradeId: '',
            stu_reg_number:'',
            subjectId: '',
            instituteId: '',
            payTypeId: '',
            amount: '',
            payment_date: this.getTodayDateTime(),
            exp_date: ''
          };
          this.currentStep = 1; // ✅ Go back to first step
        }
    //   } catch (error) {
    //     console.error("Error adding student:", error);
    //     this.errorMessage = "There was an error while adding the student.";
    //     this.successMessage = '';
    //   } finally {
    //     this.loading = false; // Stop the loading spinner
    //   }
    // },

    } catch (error) {
    console.error("Error adding student:", error);

    if (error.response && error.response.data) {
      const data = error.response.data;

      // ✅ Show all validation errors
      if (data.errors) {
        // Flatten all errors into one string separated by new lines
        this.errorMessage = Object.values(data.errors)
          .flat()
          .join("\n");
      } 
      // ✅ If it's our custom max-student error
      else if (data.error) {
        this.errorMessage = data.error;
      } 
      // ✅ Fallback
      else {
        this.errorMessage = "There was an error while adding the student.";
      }
    } else {
      this.errorMessage = "Network error. Please try again.";
    }
  } finally {
    this.loading = false;
  }
},


  },

  created() {
    this.student.payment_date = this.getTodayDateTime();
    this.fetchGrades();
    this.fetchSubjects(); // Fetch subjects when the component is created
    this.fetchInstitutes();
    this.fetchPayTypes();
  },
};
  </script>
  
  <style scoped>
  /* Responsive adjustments */
  @media (max-width: 576px) {
    .form-control,
    .form-select {
      font-size: 0.875rem;
    }
  }
  
  /* Enhancements for form appearance */
  .bg-light {
    background-color: #f8f9fa !important;
  }
  
  .shadow-sm {
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
  }
  
  .input-group-text {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
  }
  
  .form-control,
  .form-select {
    border-radius: .375rem;
  }
  
  .btn-primary {
    background-color: #007bff;
    border: none;
    border-radius: .375rem;
  }
  </style>
  